/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Freecooling1Inputs */



/**
* | output |
* | --- |
* | "Free cooling" |
*
* @param {Ahu_History_Key_Freecooling1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_freecooling1 = /** @type {((inputs?: Ahu_History_Key_Freecooling1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Freecooling1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Free cooling")
	return /** @type {LocalizedString} */ ("Free cooling")
});
export { ahu_history_key_freecooling1 as "ahu_history_key_freeCooling" }